import { ReactNode, useContext, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { DEFAULT_LANG } from "@/app/lang/constants";
import { Locales } from "@/app/lang/types";
import { ReactContext } from "@/app/providers/ReactContextProvider/react-context";

async function loadMessages(lang: Locales) {
  switch (lang) {
    case Locales.Ru:
      return (await import("@/app/lang/compiled/ru.json")).default;
    case Locales.Kz:
      return (await import("@/app/lang/compiled/kz.json")).default;
    default:
      return (await import("@/app/lang/compiled/ru.json")).default;
  }
}

type Messages = Awaited<ReturnType<typeof loadMessages>>;

export function LangProvider({ children }: { children: ReactNode }) {
  const { lang } = useContext(ReactContext);
  const [messages, setMessages] = useState<Messages>();

  useEffect(() => {
    loadMessages(lang).then((messages) => {
      setMessages(messages);
    });
  }, [lang]);

  return (
    <IntlProvider
      locale={lang}
      defaultLocale={DEFAULT_LANG}
      messages={messages}
      onError={() => null}
    >
      {children}
    </IntlProvider>
  );
}
